import Axios from 'axios'
import Vue from 'vue';
import i18n from '../../../i18n';
import get from 'lodash/get';
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import { API_HOST } from '../../../config/app-const';
import { TAG_CATEGORY } from '../../../config/const';

const state = {
  analysisArticle: {
    isBusy: false,
    isPaginationBusy: false,
    data: null,
    error: null,
    paginationError: null
  },
  mentions: {
    isBusy: false
  }
};

const getters = {
  config(state, getters, rootState, rootGetters) {
    return rootGetters['user/fetchConfig'];
  }
};

const mutations = {
  LOAD_ANALYSIS_ARTICLE_BUSY: (state, payload) => {
    state.analysisArticle.isBusy = payload;
  },
  LOAD_ANALYSIS_ARTICLE_PAGINATION_BUSY: (state, payload) => {
    state.analysisArticle.isPaginationBusy = payload;
  },
  ANALYSIS_ARTICLE_SUCCESS_REFRESH: (state, payload) => {
    state.analysisArticle.data.data = {
      ...state.analysisArticle.data.data,
      ...payload
    };
  },
  LOAD_ANALYSIS_ARTICLE_SUCCESS: (state, payload) => {

    if (
      payload.requested_at &&
      state.analysisArticle.data &&
      payload.requested_at < state.analysisArticle.data.requested_at)
      return;

    state.analysisArticle.isBusy = false;
    state.analysisArticle.data = payload;
    state.analysisArticle.error = null;
  },
  LOAD_ANALYSIS_ARTICLE_PAGINATION_SUCCESS: (state, payload) => {
    if(!state.analysisArticle?.data) return;

    state.analysisArticle.isPaginationBusy = false;
    Vue.set(state.analysisArticle.data, 'pagination', payload);
    state.analysisArticle.paginationError = null;
  },
  LOAD_ANALYSIS_ARTICLE_PAGINATION_FAIL: (state, payload) => {
    state.analysisArticle.isPaginationBusy = false;
    state.analysisArticle.paginationError = payload;
  },

  UPDATE_RELATIONSHIP_LINE_BUSY: (state, payload) => {
    state.mentions.isBusy = payload;
  },

  UPDATE_RELATIONSHIP_LINE: (state, payload) => {
    const mentions = clone(get(state, 'analysisArticle.data.data.mentions'));

    Object.keys(payload).forEach(organizationKey => {
      if(payload[organizationKey] === null) {
        delete mentions[organizationKey];
      }
      else {
        mentions[organizationKey] = payload[organizationKey];
      }
    });

    state.analysisArticle.data.data.mentions = mentions;
  },

  DELETE_RELATIONSHIP_LINE: (state, payload) => {
    delete state.analysisArticle.data.data.mentions[payload.organizationKey];
  },

  UPDATE_TAG: (state, payload) => {
    let { organizationKey, tag, tagScores, deleteRelationTag, relationTag } = payload;

    const mentions = get(state, 'analysisArticle.data.data.mentions');
    const tagIndex = mentions[organizationKey].tags.findIndex(t => t.id === tag.id);

    if(tagScores !== undefined) {
      if (tagScores.positive_score !== undefined) tag.positive_score = tagScores.positive_score;
      if (tagScores.negative_score !== undefined) tag.negative_score = tagScores.negative_score;
    }

    if(deleteRelationTag) {
      relationTag = null;
    }

    if(relationTag !== undefined) {
      tag.relation_tag = relationTag;
    }

    state.analysisArticle.data.data.mentions[organizationKey].tags[tagIndex] = tag;
  },

  DELETE_TAG: (state, payload) => {
    let { organizationKey, tag } = payload;
    const mentions = get(state, 'analysisArticle.data.data.mentions');
    state.analysisArticle.data.data.mentions[organizationKey].tags = mentions[organizationKey].tags.filter(t => t.id !== tag.id);
  },

  UPDATE_RELATIONSHIP_LINE_SCORES: (state, payload) => {
    let { organizationKey, positive_score, negative_score, score } = payload;
    if (score !== undefined) state.analysisArticle.data.data.mentions[organizationKey].total_score = score;
    if (positive_score !== undefined) state.analysisArticle.data.data.mentions[organizationKey].positive_score = positive_score;
    if (negative_score !== undefined) state.analysisArticle.data.data.mentions[organizationKey].negative_score = negative_score;
  },

  UPDATE_SOURCE_QUOTE: (state, payload) => {
    let { organizationKey, tagId, quote } = payload;

    //check if quote is already added, if no add new otherwise replace existing one
    const mentions = clone(get(state, 'analysisArticle.data.data.mentions'));
    const sourceTag = mentions[organizationKey].tags.find(t => t.id === tagId);

    const quoteIndex = sourceTag.mentions.findIndex(m => m.id === quote.id)
    if (quoteIndex === -1) {
      sourceTag.mentions.push(quote);
    }
    else {
      sourceTag.mentions[quoteIndex] = quote
    }

    state.analysisArticle.data.data.mentions = mentions;
  },

  DELETE_SOURCE_QUOTE: (state, payload) => {
    let { organizationKey, tagId, quoteId } = payload;

    const mentions = clone(get(state, 'analysisArticle.data.data.mentions'));
    const sourceTag = mentions[organizationKey].tags.find(t => t.id === tagId);

    sourceTag.mentions = sourceTag.mentions.filter(m => m.id !== quoteId);

    state.analysisArticle.data.data.mentions = mentions;
  }
};

const actions = {
  getAnalysisArticle: ({ commit, rootState, dispatch }, { projectId, articleId }) => {
    commit('LOAD_ANALYSIS_ARTICLE_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}`;

    if (window.location.search) url += window.location.search;

    Axios
      .get(url, config)
      .then((response) => {
        commit('LOAD_ANALYSIS_ARTICLE_SUCCESS', response.data)
        commit('analysisArticleIrrelevant/CLEAR_ANALYSIS_ARTICLE_IRRELEVANT', null, { root: true });
        dispatch('getAnalysisArticlePagination', { projectId, articleId });
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_ANALYSIS_ARTICLE_FAIL', error)
      })
  },
  getAnalysisArticlePagination: ({ commit, rootState }, { projectId, articleId }) => {
    commit('LOAD_ANALYSIS_ARTICLE_PAGINATION_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/pagination`;

    if (window.location.search) url += window.location.search;

    Axios
      .get(url, config)
      .then((response) => {
        commit('LOAD_ANALYSIS_ARTICLE_PAGINATION_SUCCESS', response.data?.data || response?.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_ANALYSIS_ARTICLE_PAGINATION_FAIL', error)
      })
  },

  refreshAnalysisArticle: ({ commit }, { data }) => {
    commit('ANALYSIS_ARTICLE_SUCCESS_REFRESH', data);
  },

  updateAnalysisArticle: ({ commit, rootState }, { projectId, articleId, analysisArticle, forceCall, refresh }) => {
    return new Promise((resolve, reject) => {

      forceCall ?  commit('LOAD_ANALYSIS_ARTICLE_BUSY', false) : commit('LOAD_ANALYSIS_ARTICLE_BUSY', true);
  
      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };

      const requestedAt = new Date();
  
      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/save`;

      if (window.location.search) url += window.location.search;      

      Axios
        .put(url, analysisArticle, config)
          .then((response) => {

            response.data.requested_at = requestedAt;

            commit('LOAD_ANALYSIS_ARTICLE_SUCCESS', response.data)
            resolve();
          })
          .catch(error => {
            Vue.notify({
              group: 'store_notifications',
              type: 'error',
              text: i18n.t('messages.request.error')});
    
            console.error(error);
            commit('LOAD_ANALYSIS_ARTICLE_FAIL', error);
            reject();
          })
    });
  },

  addRelationshipLine({ commit, state, dispatch, getters }, { projectId, articleId, organizationId, tag }) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RELATIONSHIP_LINE_BUSY', true);

      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/relationship_line`;

      let data = {
        organization_id: organizationId,
        tag_id: tag && tag.id,
        category: tag && tag.category
      };

      Axios
        .post(url, data, getters.config)
        .then((response) => {
          commit('UPDATE_RELATIONSHIP_LINE', response.data.data);
          const mentions = get(state, 'analysisArticle.data.data.mentions');
          resolve(mentions);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error'),
          });

          commit('LOAD_ANALYSIS_ARTICLE_FAIL', error);
          console.error(error);
          reject();
        })
        .finally(() => {
          commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
        });
    });
  },

  updateRelationshipLineScores: ({ commit, getters }, { projectId, articleId, relationshipLineId, organizationKey, tagScores }) => {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RELATIONSHIP_LINE_BUSY', true);
      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/relationship_line/${relationshipLineId}/`;

      Axios
        .put(url, tagScores, getters.config)
        .then(response => {
          commit('UPDATE_RELATIONSHIP_LINE_SCORES', {
            organizationKey,
            score: response.data.data.score,
            positive_score: response.data.data.positive_score,
            negative_score: response.data.data.negative_score,
          });

          const mentions = get(state, 'analysisArticle.data.data.mentions');
          resolve(mentions);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          commit('LOAD_ANALYSIS_ARTICLE_FAIL', error)
          console.error(error);
          reject();
        })
        .finally(() => {
          commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
        });
    });
  },

  cloneRelationshipLine({ commit, getters }, { projectId, articleId, relationshipLineId, cloneTo, tagToReplaceId, tagToAddId }) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RELATIONSHIP_LINE_BUSY', true);

      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/relationship_line/${relationshipLineId}/clone`;

      Axios
        .post(url, {organization_id: cloneTo, tag_to_replace_id: tagToReplaceId, tag_to_add_id: tagToAddId}, getters.config)
        .then((response) => {
          commit('UPDATE_RELATIONSHIP_LINE', response.data.data);
          const mentions = get(state, 'analysisArticle.data.data.mentions');
          resolve(mentions);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });
          console.error(error);
          commit('LOAD_ANALYSIS_ARTICLE_FAIL', error);
          reject();
        })
        .finally(() => {
          commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
        });
    });
  },

  addTag({ commit, dispatch, getters }, { projectId, articleId, relationshipLineId, tag }) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RELATIONSHIP_LINE_BUSY', true);

      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/relationship_line/${relationshipLineId}/tag`;

      const data = {
        id: tag.id,
        category: tag.category
      };

      if(tag.category.toLowerCase() === TAG_CATEGORY.SOURCES) {
        data.quote = tag.mentions.length && tag.mentions[0].quote ? tag.mentions[0].quote : '';
      }

      Axios
        .post(url, data, getters.config)
        .then((response) => {
          Vue.notify({
            group: 'store_notifications',
            type: 'success',
            text: i18n.t('tag.form.add.message.success')
          });

          commit('UPDATE_RELATIONSHIP_LINE', response.data.data);
          const mentions = get(state, 'analysisArticle.data.data.mentions');
          resolve(mentions);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          commit('LOAD_ANALYSIS_ARTICLE_FAIL', error);
          console.error(error);
          reject();
        })
        .finally(() => {
          commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
        });
    });
  },

  updateTag: ({ commit, getters }, { projectId, articleId, relationshipLineId, organizationKey, tag, tagScores, deleteRelationTag, relationTag }) => {
    if (!tag) return;

    return new Promise((resolve, reject) => {
      commit('UPDATE_RELATIONSHIP_LINE_BUSY', true);
      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}`;
      url += `/relationship_line/${relationshipLineId}/tag/${tag.id}`;

      if(!tagScores) {
        tagScores = { positive_score: tag.positive_score, negative_score: tag.negative_score };
      }

      if(!relationTag && tag.relation_tag) {
        relationTag = tag.relation_tag;
      }

      let data = {
        ...tagScores,
        category: tag.category
      };

      if(deleteRelationTag) {
        data.relation_tag = null;
      } else if(relationTag) {
        data.relation_tag = {
          id: relationTag.id,
          positive_score: relationTag.positive_score,
          negative_score: relationTag.negative_score
        }
      }

      Axios
        .put(url, data, getters.config)
        .then(response => {
          commit('UPDATE_TAG', { organizationKey, tag, tagScores, deleteRelationTag, relationTag });
          commit('UPDATE_RELATIONSHIP_LINE', response.data.data);

          const mentions = get(state, 'analysisArticle.data.data.mentions');
          resolve(mentions);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          commit('LOAD_ANALYSIS_ARTICLE_FAIL', error)
          console.error(error);
          reject();
        })
        .finally(() => {
          commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
        });
    });
  },

  deleteMention: ({ commit, getters }, { projectId, articleId, relationshipLineId, organizationKey, tag }) => {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RELATIONSHIP_LINE_BUSY', true);
      const isTag = tag && tag.category.toLowerCase() !== TAG_CATEGORY.ORGANIZATION ? true : false;
      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/`;

      const config = clone(getters.config);
      if (isTag) {
        url += `relationship_line/${relationshipLineId}/tag/${tag.id}`;

        if (tag.category) {
          config.data = { category: tag.category }
        }
      } else {
        url += `relationship_line/${relationshipLineId}`;
      }

      Axios
        .delete(url, config)
        .then(response => {
          if (isTag) {
            commit('UPDATE_RELATIONSHIP_LINE', response.data.data);
          }
          else {
            commit('DELETE_RELATIONSHIP_LINE', {
              organizationKey
            });
          }

          const mentions = get(state, 'analysisArticle.data.data.mentions');
          resolve(mentions);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          commit('LOAD_ANALYSIS_ARTICLE_FAIL', error)
          console.error(error);
          reject();
        })
        .finally(() => {
          commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
        });
    });
  },

  updateSourceMention: ({ commit, getters }, { projectId, articleId, relationshipLineId, organizationKey, tagId, quote }) => {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RELATIONSHIP_LINE_BUSY', true);

      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/`;
      url += `relationship_line/${relationshipLineId}/tag/${tagId}/quote`;

      //update existent source quote
      if(quote.id) {
        url += `/${quote.id}`;

        Axios
          .put(url, {text: quote.quote}, getters.config)
          .then((response) => {
            commit('UPDATE_SOURCE_QUOTE', {
              organizationKey,
              tagId,
              quote
            });

            const mentions = get(state, 'analysisArticle.data.data.mentions');
            resolve(mentions);
          })
          .catch(error => {
            Vue.notify({
              group: 'store_notifications',
              type: 'error',
              text: i18n.t('messages.request.error')
            });

            commit('LOAD_ANALYSIS_ARTICLE_FAIL', error);
            console.error(error);
            reject();
          })
          .finally(() => {
            commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
          });
      }
      //Add new source quote
      else {
        Axios
          .post(url, {text: quote.quote}, getters.config)
          .then((response) => {
            commit('UPDATE_SOURCE_QUOTE', {
              organizationKey,
              tagId,
              quote: {
                id: response.data.data.id,
                quote: response.data.data.text
              }
            });

            const mentions = get(state, 'analysisArticle.data.data.mentions');
            resolve(mentions);
          })
          .catch(error => {
            Vue.notify({
              group: 'store_notifications',
              type: 'error',
              text: i18n.t('messages.request.error')
            });

            console.error(error);
            commit('LOAD_ANALYSIS_ARTICLE_FAIL', error);
            reject();
          })
          .finally(() => {
            commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
          });
      }
    });
  },

  deleteSourceMention: ({ commit, rootState, getters }, { projectId, articleId, relationshipLineId, organizationKey, tagId, quoteId }) => {
    return new Promise((resolve, reject) => {
      commit('LOAD_ANALYSIS_ARTICLE_BUSY', true);

      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}`;
      url += `/relationship_line/${relationshipLineId}/tag/${tagId}/quote/${quoteId}`;

      Axios
        .delete(url, getters.config)
        .then((response) => {
          commit('DELETE_SOURCE_QUOTE', {
            organizationKey,
            tagId,
            quoteId
          });

          const mentions = get(state, 'analysisArticle.data.data.mentions');
          resolve(mentions);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          commit('LOAD_ANALYSIS_ARTICLE_FAIL', error);
          console.error(error);
          reject();
        })
        .finally(() => {
          commit('LOAD_ANALYSIS_ARTICLE_BUSY', false);
        });
    });
  },

  undoAction: ({ commit, state, getters }, { projectId, articleId, relationshipLineId, organizationKey, data }) => {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RELATIONSHIP_LINE_BUSY', true);

      let url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}`;
      url += `/relationship_line/${relationshipLineId}/undo`;

      Axios
        .put(url, data, getters.config)
        .then((response) => {
          commit('UPDATE_RELATIONSHIP_LINE', response.data.data);
          const mentions = get(state, 'analysisArticle.data.data.mentions');
          resolve(mentions);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          commit('LOAD_ANALYSIS_ARTICLE_FAIL', error);
          console.error(error);
          reject();
        })
        .finally(() => {
          commit('UPDATE_RELATIONSHIP_LINE_BUSY', false);
        });
    });
  },

  getArticleHistory: ({ commit, state, getters }, { projectId, articleId }) => {
    const url = `${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/history`;
    return Axios.get(url, getters.config);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};